import type { HTMLAttributes, ReactNode } from "react";

import { cn, cv, type VariantProps } from "../utils";

const badge = cv(
  [
    "shrink-0 bg-light inline-flex gap-1 items-center px-1.5 py-1 text-center text-sm align-baseline",
    "justify-center font-bold leading-none border min-w-6 min-h-[1.75em] border-ui",
  ],
  {
    variants: {
      variant: {
        default: "text-main",
        neutral: "text-ui-dark",
        success: "text-success",
        danger: "text-danger",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface NcBadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badge> {
  children: ReactNode;
}

export const NcBadge = ({ variant = "default", children, className, ...props }: NcBadgeProps) => {
  return (
    <span data-nc="NcBadge" className={cn(badge({ variant }), className)} {...props}>
      {children}
    </span>
  );
};
